import axiosInstance from './axiosConfig';

export const getPostsApi = (params) => axiosInstance.get('/posts', { params });
export const getPostApi = (id) => axiosInstance.get(`/posts/${id}`);
export const createPostApi = (payload) => axiosInstance.post('/posts', payload);
export const updatePostApi = (id, payload) => axiosInstance.put(`/posts/${id}`, payload);
export const deletePostApi = (id) => axiosInstance.delete(`/posts/${id}`);

export const uploadPostImageApi = (id, file) => {
  const formData = new FormData();
  formData.append('image', file);
  return axiosInstance.post(`/posts/${id}/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const uploadPostGalleryApi = (id, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('images', file));
  return axiosInstance.post(`/posts/${id}/gallery`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getPublicPostsApi = (params) => axiosInstance.get('/public/posts', { params });
export const getPublicPostApi = (id) => axiosInstance.get(`/public/posts/${id}`);
